import { axiosInstance } from "../../../api/axiosInstance.tsx";

export interface RAPSearchParams {
  keyword?: string;
  projectId?: string;
  totalPrice?: string;
  rabId?: string;
  biddingId?: string;
  ppn?: string;
  nilaiKontrak?: string;
  startDate?: string;
  endDate?: string;
  startDateS?: string;
  endDateS?: string;
  startDateE?: string;
  endDateE?: string;
  valueEstimation?: string;
  valueMin?: string;
  valueMax?: string;
  limit?: number;
  offset?: number;
  orderBy?: string;
  order?: string;
}

export const getRap = async (params: RAPSearchParams = {}) => {
  const response = await axiosInstance.get("/sales/rap/search_rap", {
    params,
  });
  return response.data;
};


export const fetchRapPhotoBlob = async (filename: string): Promise<string | null> => {
  try {
    const token = localStorage.getItem("token");

    const response = await axiosInstance.get(`/sales/rap/photo/${filename}`, {
      responseType: "blob",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    const objectUrl = URL.createObjectURL(response.data);
    return objectUrl;
  } catch (error) {
    console.error("Gagal mengambil foto:", error);
    return null;
  }
};



// Step 1: Create Project
export const createRap = async (data) => {
  const response = await axiosInstance.post(`/sales/rap/create_rap`, data);
  return response.data; // contains the project `id` or `code`
};


// Step 2: Upload Photo by Project ID
export const uploadRapPhoto = async (rapId, file) => {
  const formData = new FormData();
  formData.append("photo", file);

  return axiosInstance.post(`/sales/rap/upload_photo/${rapId}`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};


// Edit Project
export const editRap = async (data) => {
  const formData = {
    projectName: data.projectName,
    projectAddress: data.projectAddress,
    region: data.region,
    projectType: data.projectType,
    projectEmail: data.projectEmail,
    managerName: data.managerName,
    contactNumber: data.contactNumber,
  };

  const response = await axiosInstance.put(`/sales/rap/update_rap/${data.id}`, data);
  return response.data; // contains the project `id` or `code`
};

export const deleteRap = async (projectId: string) => {
  const response = await axiosInstance.delete(`/sales/rap/delete_rap/${projectId}`);
  return response.data;
};


// RAP DETAILS

export interface RAPDetailSearchParams {
  keyword?: string;
  rapId?: string;
  ahsId?: string;
  volume?: string;
  totalHarga?: string;
  limit?: number;
  offset?: number;
  orderBy?: string;
  order?: string;
}

export const getRapDetail = async (params: RAPDetailSearchParams = {}) => {
  const response = await axiosInstance.get("/sales/rap/search_rap_detail", {
    params,
  });
  return response.data;
};

export const viewRapDetail = async (id: string) => {
  const response = await axiosInstance.get(`/sales/rap/view_rap_detail/${id}`);
  return response.data;
};


export const createRapDetail = async (data) => {
  const response = await axiosInstance.post(`/sales/rap/create_rap_detail`, data);
  return response.data; // contains the project `id` or `code`
};


export const editRapDetail = async (data) => {

  const response = await axiosInstance.put(`/sales/rap/update_rap_detail/${data.id}`, data);
  return response.data; // contains the project `id` or `code`
};

export const deleteRapDetail = async (id: string) => {
  const response = await axiosInstance.delete(`/sales/rap/delete_rap_detail/${id}`);
  return response.data;
};

// SCurve

export interface SCurveSearchParams {
  keyword?: string;
  rapDetailId?: string;
  rapId?: string;
  nilaiPekerjaan?: string;
  bobot?: string;
  durasiMinggu?: string;
  bobotMingguan?: string;
  limit?: number;
  offset?: number;
  orderBy?: string;
  order?: string;
}

export const getSCurve = async (params: SCurveSearchParams = {}) => {
  const response = await axiosInstance.get("/sales/scurverap/search_scurve", {
    params,
  });
  return response.data;
};

export const viewSCurve = async (id: string) => {
  const response = await axiosInstance.get(`/sales/scurverap/view_scurve/${id}`);
  return response.data;
};

export const graphSCurve = async (rapId: string) => {
  const response = await axiosInstance.get(`/sales/scurverap/graph_scurve/${rapId}`);
  return response.data;
};


export const createSCurve = async (data) => {
  const response = await axiosInstance.post(`/sales/scurverap/create_scurve`, data);
  return response.data; // contains the project `id` or `code`
};


export const editSCurve = async (data) => {

  const response = await axiosInstance.put(`/sales/scurverap/update_scurve/${data.id}`, data);
  return response.data; // contains the project `id` or `code`
};

export const deleteSCurve = async (id: string) => {
  const response = await axiosInstance.delete(`/sales/scurverap/delete_scurve/${id}`);
  return response.data;
};